import React from 'react';
import { Button } from 'easyship-components';
import { FormattedMessage } from 'react-intl';
import { useShipmentViewContext } from '@/features/ShipmentView/providers/ShipmentViewProvider/context';
import MixpanelService from '@/utils/mixpanel.service';
import { useShowTypeModal } from '@/features/Claim/hooks/general/useShowTypeModal';
import { useCompany } from '@app/hooks/general/useCompany';

export function FileClaimButton() {
  const { easyshipCompanyId } = useCompany();
  const { shipmentItem, isClaimable } = useShipmentViewContext();

  const { showTypeModal } = useShowTypeModal();

  const onClickHandler = () => {
    MixpanelService.track('Insurance Claim Page Viewed', {
      easyship_company_id: easyshipCompanyId,
      easyship_claim_id: shipmentItem?.claim?.id,
      review_state: shipmentItem?.claim?.reviewState,
      payment_state: shipmentItem?.claim?.paymentState,
      provider_claim_status: shipmentItem?.claim?.providerClaimStatus,
    });
    showTypeModal(shipmentItem?.easyshipShipmentId);
  };

  return !isClaimable ? null : (
    <Button onClick={onClickHandler} className="mx-auto mt-6">
      <FormattedMessage id="shipments.modal.insurance.claim-button" />
    </Button>
  );
}

export default FileClaimButton;
